import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.ConceptoFactura;
export interface Props {
    value: Entity[];
}

//TODO: Hacer estos calculos en el backend y ponerlos en un ConceptoDTO

function subtotal(concepto: Entity) {
    const value = concepto;
    const unitario = value.PrecioUnitario ? value.PrecioUnitario : 0;
    const cantidad = value.Cantidad ? value.Cantidad : 0;
    return unitario * cantidad;
}

function total(concepto: Entity) {
    const value = concepto;
    const totalImpuestos = impuestos(concepto);
    return subtotal(value) + totalImpuestos;
}

function totalMorales(concepto: Entity) {
    const value = concepto;
    const totalImpuestos = impuestos(concepto);
    const totalRetenciones = retenciones(concepto);
    return subtotal(value) + totalImpuestos - totalRetenciones;
}

function impuestos(concepto: Entity) {
    const value = concepto;
    const iva = value.TasaIva ? value.TasaIva : 0;
    const ieps = value.TasaIeps ? value.TasaIeps : 0;
    const totalIva = subtotal(value) * iva;
    const totalIeps = subtotal(value) * ieps;
    return totalIva + totalIeps;
}

function retenciones(concepto: Entity) {
    const value = concepto;
    const ivaRetencion = value.TasaRetencionIva ? value.TasaRetencionIva : 0;
    const totalRetencion = subtotal(value) * ivaRetencion;
    return totalRetencion;
}

const columnasFijas: kea.Grid2Column<Entity>[] = [
    { title: "Descripcion", cell: x => ({ data: x.Descripcion }) },
    { title: "Cantidad", cell: x => ({ data: x.Cantidad }) },
    { title: "Precio unitario", cell: x => ({ data: kea.formatCurrency(x.PrecioUnitario) }) },
    { title: "Subtotal", cell: x => ({ data: kea.formatCurrency(subtotal(x)) }) },
    { title: "Impuestos", cell: x => ({ data: kea.formatCurrency(impuestos(x)) }) },
    { title: "Retenciones", cell: x => ({ data: kea.formatCurrency(retenciones(x)) }) },
    { title: "Total", cell: x => ({ data: kea.formatCurrency(totalMorales(x)) }) },
];

/**Obtiene las columnas del grid */
export function columnas(): kea.Grid2Column<Entity, undefined>[] {
    return [...columnasFijas];
}

/**Establece las propiedades de descripcion para ser mostradas correctamente en el listado */
async function setDescripciones(x: Entity): Promise<Entity> {
    return x;
}

/**
* Listado de ConceptoFactura
*/
class ConceptoFacturaListNoRx extends React.PureComponent<Props> {
    render() {
        const cols = columnas();
        return (
            <div>
                <kea.Title titulo="Conceptos" />
                <kea.Grid2 items={this.props.value} columnas={cols} />
            </div>
        );
    }
}
export const ConceptoFacturaList = kea.mapProps(componentToRx(ConceptoFacturaListNoRx), x => ({ ...x, value: x.value || [] }));


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturaciononline/edit/conceptosfacturas.tsx